import { PipelineType } from '@revelio/data-access';

export const SENTIMENT_DATASETS = [
  PipelineType.SentimentScores,
  PipelineType.IndividualReviews,
  PipelineType.ReviewTrends,
];
